import styled, { css, keyframes } from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import TableCompany from '@deprecated-ui/company/Table';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

export const BoxHeader = styled(Flex)`
  align-items: center;
  background: ${color.light};
  border-collapse: collapse;
  border-bottom: solid 1px;
  border-color: ${color.gainsboro};
  cursor: pointer;
  justify-content: space-between;
  padding: 15px 20px;

  .hide-on-mobile {
    display: none;
  }

  .show-on-mobile {
    display: flex;
  }

  @media ${device.tablet} {
    border: solid 1px;
    border-color: ${color.gainsboro};
    margin-bottom: 16px;
    border-radius: 3px;

    .hide-on-mobile {
      display: flex;
    }

    .show-on-mobile {
      display: none;
    }
  }
`;

interface HeaderLinkProps {
  active?: boolean;
}

export const HeaderLink = styled(Text)<HeaderLinkProps>`
  color: ${({ active }) => (active ? color.dimgray : color.primary)};
  font-family: var(--bold-font);
  font-size: 16px;
  weight: 700;
`;

export const BoxSectors = styled.div`
  background: ${color.light};
  border-collapse: collapse;
  border-bottom: solid 1px;
  border-color: ${color.gainsboro};
  display: grid;
  font-family: var(--regular-font);
  gap: 3px;
  padding: 20px;
  width: 100%;

  a {
    color: ${color.highempahis};
  }

  a:hover,
  a:active,
  a:focus {
    color: ${color.primary};
  }

  @media ${device.tablet} {
    border: solid 1px;
    border-color: ${color.gainsboro};
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 16px;
    border-radius: 3px;
  }

  @media ${device.laptop} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const BoxTable = styled.div`
  background: ${color.light};
  border-collapse: collapse;
  border-bottom: solid 1px;
  border-color: ${color.gainsboro};

  @media ${device.tablet} {
    border: solid 1px;
    border-color: ${color.gainsboro};
    margin-bottom: 16px;
    border-radius: 3px;
  }
`;

export const Th = styled(Text).attrs((props) => ({
  // @ts-expect-error
  p: props.p || '15px 0px 15px 35px',
}))`
  border-bottom: solid 1px ${color.gainsboro};
`;

export const Td = styled(Text).attrs((props) => ({
  // @ts-expect-error
  p: props.p || '0 20px',
  // @ts-expect-error
  family: props.bold && 'bold',
  height: '44px',
}))`

  a {
    color: inherit;
  }
`;

export const ButtonFollow = styled.button`
  background: ${color.light};
  border-radius: 2px;
  border: 1px solid #dadada;
  cursor: pointer;
  display: inline-block;
  font-weight: 400;
  height: 27px;
  line-height: 27px;
  margin: 5px 0;
  padding: 0 10px;
  text-align: center;
  width: 85px;

  &.following {
    background: #00ab6b;
    border-color: #00ab6b;
    color: #fff;
  }
`;

interface TableProps {
  isLoading?: boolean;
}

export const Table = styled(TableCompany)<TableProps>`
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background: transparent;
  }

  .ant-table-column-sort {
    background: transparent;
  }

  .ant-table-tbody tr td {
    border-bottom: solid 1px ${color.gainsboro}!important;
  }

  .ant-table-column-sorters {
    padding: 0px 5px 0px 0px;
    width: 100%;
    display: flex;

    & > span:nth-child(1) {
      width: 100%;
      margin-right: 1px;
    }

    .ant-table-column-sorter {
      .ant-table-column-sorter-up.active,
      .ant-table-column-sorter-down.active {
        color: ${color.highempahis};
        display: block;
      }
    }
  }

  .ant-table-column-sorter {
    visibility: hidden;
    margin-left: 0px;
  }

  th:hover {
    .ant-table-column-sorter {
      visibility: visible;
    }
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      display: none;
    `}

  .hide-on-mobile {
    display: none;

    @media ${device.tablet} {
      display: table-cell;
    }
  }

  .hide-on-tablet {
    display: none;

    @media ${device.laptop} {
      display: table-cell;
    }
  }

  .hide-cell {
    display: none;
  }
`;

const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled.div`
  min-width: 100px;
  min-height: 100px;
  position: relative;
  :before {
    content: 'Loading…';
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    margin-top: 0;
    margin-left: 0;
  }
  :before {
    content: '';
    border-radius: 50%;
    border-top: 2px solid ${color.veryLightGrey};
    border-right: 2px solid transparent;
    animation: ${loadingAnimation} 0.7s linear infinite;
    -webkit-animation: ${loadingAnimation} 0.7s linear infinite;
  }
`;
